// 2_components/footer_instagram.js
// Adds the Instagram profile name (read from the footer social link) and an
// image placeholder into the "follow on Instagram" button of the footer widget.

export function init() {
	footer = document.querySelector("#footer");
	if (!footer) return;

	// Edit the "follow on Instagram" button in the widget
	editFollowOnInstagramWidgetButton();
}

let footer;

function editFollowOnInstagramWidgetButton() {
	const instagramWidgetFollowBtn = footer.querySelector(".instagram-follow-btn a");
	if (!instagramWidgetFollowBtn) return;

	// NOTE: no null check on the social link — throws if a.footer-social-link.instagram
	// is missing while the follow button exists (same as the old code).
	const instagramProfileName = footer
		.querySelector("a.footer-social-link.instagram")
		.getAttribute("href")
		.replace("https://www.instagram.com/", "")
		.replace("/", "");
	if (!instagramProfileName) return;

	const instagramProfileNameElement = document.createElement("span");
	instagramProfileNameElement.className = "instagram-profile-name";
	instagramProfileNameElement.textContent = instagramProfileName;

	const instagramImagePlaceholder = document.createElement("span");
	instagramImagePlaceholder.className = "instagram-image-placeholder";

	instagramWidgetFollowBtn.prepend(instagramProfileNameElement);
	instagramWidgetFollowBtn.prepend(instagramImagePlaceholder);
}
